import styled from 'styled-components';
import { Device } from '../constants/device';

export const Title = styled.h1`
  font-size: 42px;
  margin-top: 30px;
  margin-bottom: 20px;

  ${Device.downTablet} {
    font-size: 28px;
    text-align: center;
  }
`;
